
import { useEffect } from 'react';
import { Box, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { ProgressBarComponent } from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { useUserStore } from '@roc/feature-app-core';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { PayoffTodos } from './payoffTodos';

export const PayoffDetailsModalContent = observer(({ loanId }: { loanId: string; }) => {
  const { documentStore } = useDocumentStore();
  const { userStore } = useUserStore();
  const { payoffRequestStore } = usePayoffRequestStore();

  if (!payoffRequestStore.selectedPayoff || !documentStore.drawDocuments) {
    return <></>;
  }

  const displayProgressBar = payoffRequestStore.selectedPayoff.loanPayoffStages?.length > 0;

  return (
    <Grid container spacing={2}>
      {displayProgressBar && (
        <Grid item xs={12}>
          <ProgressBarComponent
            progressArray={
              payoffRequestStore.selectedPayoff.loanPayoffStages
            }
            active={payoffRequestStore.selectedPayoff.payoffStatus}
            allowNonExistingStep
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <PayoffTodos isCPortal={!userStore.globalStore.isInternalPortal} loanId={+loanId} payoffId={payoffRequestStore?.selectedPayoffId} />
      </Grid>
      <Grid item xs={12}>
        <Box style={{ height: "30px" }} />
      </Grid>
    </Grid>
  );
}
);

export default PayoffDetailsModalContent;